import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function UniqueMethod() {
  return <section className="py-24 bg-navy text-cream relative overflow-hidden" data-id="element-177">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-178">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber/5 rounded-full blur-3xl" data-id="element-179"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-rose/5 rounded-full blur-3xl" data-id="element-180"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-182">
          <div className="inline-flex items-center justify-center p-3 bg-amber/10 rounded-full mb-8" data-id="element-183">
            <Sparkles className="w-6 h-6 text-amber" data-id="element-184" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-185">
            El Método de{' '}
            <span className="text-amber italic" data-id="element-186">Cercanía Gradual</span>
          </h2>

          <div className="space-y-8 text-lg md:text-xl text-cream/80 leading-relaxed font-light max-w-3xl mx-auto" data-id="element-187">
            <p data-id="element-188">
              A diferencia de los entrenamientos de sueño tradicionales, este
              sistema no se basa en la separación, sino en la{' '}
              <strong className="text-amber font-normal" data-id="element-189">
                transferencia de confianza
              </strong>
              .
            </p>
            <p data-id="element-190">
              A través de una transición de 7 días, retiras tu ayuda física de
              forma tan sutil que tu bebé aprende a conciliar el sueño
              sintiéndose siempre acompañado y seguro.
            </p>
            <p className="text-2xl font-serif italic text-cream mt-12" data-id="element-191">
              Es ciencia aplicada con amor de madre.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}